import UserBlacklistList from './List';

const UserBlacklistIndex = {
  UserBlacklistList, 
};

export default UserBlacklistIndex;